import { Box, Grid, Hidden, IconButton, Skeleton, Theme, Typography, useTheme } from "@mui/material";
import { ChartIcon, CurrencyIcon, HideIcon, MoneyGrow, PercentageIcons, ViewIcon } from "../../../assets/SvgIcons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CustomDropdown from "../../../lib/formik/CustomDropdown";
import { ErrorText } from "../../dashboard/chart/CustomeLineChart";
import CustomePieChart from "../../dashboard/chart/CustomePieChart";
import CustomTable from "../common/customTable";
import { QuantitativeAnalysisHead, QuantitativeAnalysisTable, TopSchemeTableHead, TopSchemTable } from "./common/Table";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { Order, SortingObj, navigationData } from "../types";
import BreadCrum from "../../../lib/BreadCrum";
import InvestorLevelAMCPerformanceAnalysis from "../../dashboard/table/InvestorLevelAMCPerformance";
import { AMCPerformanceProductsRes, GetQuantitativeAnalysisResponseBody, GetTop10SchemesRes, MarketCapAllocationRes, PortfolioExposureMFRes, QuantitativeAnalysisData, TotalCardValuesRes, RatingAndMaturityRes, IssuerCategoryRes } from "../../../redux-store/types/products";
import { getMarketCapAllocation, getProductsAMCPerformance, getQuantitativeAnalysis, portfolioExposureInCategory, top10Schemes, totalCardValuesApi, getRatingAndMaturity, getIssuerCategoryAllocation } from "../../../redux-store/actions/product";
import { formatCurrency, isRMLikeRole } from "../../../utils/utilityFunctions";
import useQuery from "../../../utils/useQuery";
import { TableCell, TableRow } from "@mui/material";



type CardProps = {
    Icons: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
    title: string
    value: string
    color?: string
    loading?: boolean
    percent?: boolean
    percentageValue?: number
    maskedData?: boolean
}



const Card = (props: CardProps) => {
    const { Icons, title, value, color, loading, percent, percentageValue, maskedData } = props
    const { palette } = useTheme()
    return (
        <Box sx={(theme: Theme) => (
            { display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '15px', padding: '0px 18px', height: '102px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)' }
        )}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Icons />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '10px', width: '80%' }}>
                {loading ? <>
                    <Skeleton animation="wave" sx={{ width: '60%' }} />
                    <Skeleton animation="wave" sx={{ width: '100%' }} />
                </> : <>
                    <Typography variant="subtitle_500" color={palette.text.primary}>{title}</Typography>
                    {maskedData ?
                        <Typography variant="body_600" color='text.primary'>****</Typography>
                        : !percent ? (
                            <Typography
                                variant="h3"
                                color={color ? color : palette.text.primary}
                                sx={{ textWrap: 'nowrap' }}
                            >
                                {value}
                            </Typography>
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    columnGap: "5px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <Typography
                                    variant="h3"
                                    color={color ? color : palette.text.primary}
                                    sx={{ textWrap: 'nowrap' }}
                                >
                                    {value}
                                </Typography>
                                <Typography
                                    variant="h3"
                                    color={color ? color : palette.text.primary}
                                    sx={{ textWrap: 'nowrap' }}
                                >
                                    ({percentageValue ? percentageValue.toFixed(2) : '0'}%)
                                </Typography>
                            </Box>
                        )}
                </>}

            </Box>
        </Box>
    )
}

const ResponsiveCard = (props: { align?: 'left' | 'right', textAlign?: 'left' | 'right', title: string, value: string, color?: string, maskedData?: boolean }) => {
    const { palette } = useTheme()
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: props.align === 'right' ? 'flex-end' : 'flex-start' }}>
            <Typography variant="subtitle_600" align={props.align ? props.align : 'left'} color={palette.text.secondary}>{props.title}</Typography>
            {props?.maskedData
                ? (
                    <Typography variant="body_600" color='text.primary' align={props.textAlign || props.align || 'left'}>***</Typography>
                ) : (
                    <Typography variant="body_500" color={props.color || palette.text.primary} align={props.textAlign || props.align || 'left'}>{props.value}</Typography>
                )
            }
        </Box>
    )
}
export default function CategoryWiseActionItems(): JSX.Element {
    const history = useHistory();
    const { state, pathname: pathName } = history.location;
    const { category } = state as { category: string };
    const { palette } = useTheme()
    const tabsList = ['Equity', 'Debt', 'Hybrid']
    const [selectedTab, setSelectedTab] = useState<string>(category);
    const dispatch = useDispatch();
    const [categoryWiseAmcData, setCategoryWiseAmcData] = useState<AMCPerformanceProductsRes>({} as AMCPerformanceProductsRes)
    const [categoryWiseAmcDataLoading, setCategoryWiseAmcDataLoading] = useState<boolean>(false)
    const [amcSortingObj, setAMCSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
    const [schemesLoader, setSchemesLoader] = useState<boolean>(false);
    const [cardLoader, setCardLoader] = useState<boolean>(false)
    const [cardValues, setCardValues] = useState<TotalCardValuesRes>({} as TotalCardValuesRes)
    const [topSchemesData, setTopSchemesData] = useState<GetTop10SchemesRes>({} as GetTop10SchemesRes);
    const [portfolioFilter, setPortfolioFilter] = useState<string | number>(1);
    const [portfolioLoader, setPortfolioLoader] = useState<boolean>(false)
    const [portfolioExposureData, setPortfolioExposureData] = useState<PortfolioExposureMFRes>({} as PortfolioExposureMFRes)
    const [marketCapData, setMarketCapData] = useState<MarketCapAllocationRes>({} as MarketCapAllocationRes)
    const [creditFilter, setCreditFilter] = useState<string | number>(1);
    const [creditLoader, setCreditLoader] = useState<boolean>(false)
    const [creditData, setCreditData] = useState<RatingAndMaturityRes>({} as RatingAndMaturityRes)
    const [issuerFilter, setIssuerFilter] = useState<string | number>(1);
    const [issueLoader, setIssueLoader] = useState<boolean>(false)
    const [issuerData, setIssuerData] = useState<IssuerCategoryRes>({} as IssuerCategoryRes)
    const [marketCapDataLoading, setMarketCapDataLoading] = useState<boolean>(false)
    const [quantitativeAnalysisData, setQuantitativeAnalysisData] = useState<Array<QuantitativeAnalysisData>>([])
    const [quantitativeAnalysisDataLoading, setQuantitativeAnalysisDataLoading] = useState<boolean>(false)

    const query = useQuery()
    const urlPortfolio = query.get('portfolio')


    const navState = state as navigationData
    const { investorClientId, familyMemberId = "" } = useSelector((store: RootStateType) => store.id);
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const clientCode = navState?.clientCode || investorClientId || "";
    const initialRouter = pathName.split('/').filter((item) => item !== '')
    const [maskedData, setMaskedData] = useState<boolean>(false)

    const rmRouterPath = initialRouter[0] === 'product' ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,

        },
        {
            name: `${selectedTab || category}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,

        }

    ] : [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: `${initialRouter[1]} ${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        },
        {
            name: 'Detailed Portfolio Holdings',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: navState?.clientCode || ""
            },
            search: `tab=Overview&portfolio=${urlPortfolio ?? ""}`
        },
        {
            name: `${selectedTab || category}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        }
    ]

    const investorRouterPath = [
        ...(familyMemberId
            ?
            [{
                name: 'View Family',
                path: `/investor-family/family-profile/${familyMemberId}`,
            },
            {
                name: `${initialRouter[1]}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            }]
            :
            [{
                name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
                path: '/investor-dashboard',
            }]
        ),
        {
            name: 'Mutual Funds',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}` : `/${initialRouter[0]}/${initialRouter[1]}`),
            state: {
                clientCode: navState?.clientCode || ""
            }
        },
        {
            name: `${selectedTab || category}`,
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`),
            state: {
                clientCode: navState?.clientCode || ""
            }
        },

    ]
    const { iwappRmId } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)

    const totalCardValues = async (selectedCategory: string) => {
        try {
            setCardLoader(true);

            const cardValuesRes = await (dispatch(totalCardValuesApi({
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                clientCode,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            })) as unknown as Promise<TotalCardValuesRes>)
            setCardValues(cardValuesRes)

        } catch (e) {
            console.log("Error", e);
        } finally {
            setCardLoader(false);
        }
    }
    const fetchInvestorLevelAmcPerformance = async ({
        orderBy = 'investedValue',
        order = 'desc',
        selectedCategory
    }: {
        orderBy?: string;
        order?: Order;
        selectedCategory: string;
    }) => {
        try {
            setCategoryWiseAmcDataLoading(true);
            const amcPerformancePayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                sortItem: orderBy,
                order: order,
                category: selectedCategory,
                clientCode,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }
            const amcPerformanceRes = await (dispatch(getProductsAMCPerformance(amcPerformancePayload)) as unknown as Promise<AMCPerformanceProductsRes>)
            setCategoryWiseAmcData(amcPerformanceRes)
        } catch (e) {
            console.log("Error:", e)
        } finally {
            setCategoryWiseAmcDataLoading(false);
        }
    }

    const getPortfolioExposure = async (selectedCategory: string) => {
        try {
            setPortfolioLoader(true);
            const portfolioExposurePayload = {
                clientCode: clientCode,
                filter: portfolioFilter === 1 ? "Sectors" : "Companies",
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }
            const portfolioAllocationRes = await (dispatch(portfolioExposureInCategory(portfolioExposurePayload)) as unknown as Promise<PortfolioExposureMFRes>);
            setPortfolioExposureData({ ...portfolioAllocationRes, result: { ...portfolioAllocationRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setPortfolioLoader(false)
        }
    }

    const marketCap = async (selectedCategory: string) => {
        try {
            setMarketCapDataLoading(true);
            setMarketCapData({} as MarketCapAllocationRes);
            const marketCapPayload = {
                clientCode: clientCode,
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }
            const marketCapRes = await (dispatch(getMarketCapAllocation(marketCapPayload)) as unknown as Promise<PortfolioExposureMFRes>);
            setMarketCapData({ ...marketCapRes, result: { ...marketCapRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setMarketCapDataLoading(false)
        }
    }

    const getTopSchemes = async ({
        orderBy = 'amount',
        order = 'desc',
        selectedCategory
    }: {
        orderBy?: string;
        order?: Order;
        selectedCategory: string;
    }) => {
        try {
            setSchemesLoader(true);
            const topSchemesPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                // sortItem: orderBy,
                // order: order,
                category: selectedCategory,
                clientCode,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF",
                isTop: true
            }
            const schemesRes = await (dispatch(top10Schemes(topSchemesPayload)) as unknown as Promise<GetTop10SchemesRes>)
            setTopSchemesData(schemesRes)
        } catch (e) {
            console.log('Error', e)
        } finally {
            setSchemesLoader(false);
        }
    }

    const fetchRatingAndMaturity = async (selectedCategory: string) => {
        try {
            setCreditLoader(true);
            const ratingMaturityPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode,
                category: selectedCategory,
                filter: creditFilter === 1 ? 'ratingName' : 'maturityYear',
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }
            const ratingAndMaturityRes = await (dispatch(getRatingAndMaturity(ratingMaturityPayload)) as unknown as Promise<RatingAndMaturityRes>)
            setCreditData({ ...ratingAndMaturityRes, result: { ...ratingAndMaturityRes?.result } })
        }
        catch (e) {
            console.log('Error', e);
        } finally {
            setCreditLoader(false);
        }
    }
    const fetchIssuerAllocation = async (selectedCategory: string) => {
        try {
            setIssueLoader(true);
            const issuerAllocationPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode,
                category: selectedCategory,
                filter: issuerFilter === 1 ? 'Issuer' : 'Instruments',
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }
            const issuerAllocationRes = await (dispatch(getIssuerCategoryAllocation(issuerAllocationPayload)) as unknown as Promise<IssuerCategoryRes>)
            setIssuerData({ ...issuerAllocationRes, result: { ...issuerAllocationRes?.result } })
        }
        catch (e) {
            console.log('Error', e);
        } finally {
            setIssueLoader(false);
        }
    }
    const fetchQuantitativeAnalysisData = async (currentTab: string) => {
        try {
            setQuantitativeAnalysisDataLoading(true)

            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode: `${clientCode}`,
                category: currentTab,
                // portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : urlPortfolio ?? "",
                assetGroup: "MF"
            }

            const { result = [], message = "", isSuccess } = await (dispatch(getQuantitativeAnalysis(payload)) as unknown as Promise<GetQuantitativeAnalysisResponseBody>)

            if (isSuccess) {
                const modifiedRes = currentTab === "Debt" ? result.filter(obj => (obj?.amcname !== 'P/E' && obj.amcname !== 'P/B')) : result

                setQuantitativeAnalysisData(modifiedRes)
            } else {
                console.log(message)
            }


        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setQuantitativeAnalysisDataLoading(false)
        }
    }

    useEffect(() => {
        selectedTab != 'Debt' && getPortfolioExposure(selectedTab)
    }, [portfolioFilter])

    useEffect(() => {
        selectedTab === 'Debt' && fetchRatingAndMaturity(selectedTab)
    }, [creditFilter])

    useEffect(() => {
        selectedTab === "Debt" && fetchIssuerAllocation(selectedTab)
    }, [issuerFilter])

    useEffect(() => {
        fetchInvestorLevelAmcPerformance({ selectedCategory: selectedTab });
        getTopSchemes({ selectedCategory: selectedTab })
        totalCardValues(selectedTab)
        selectedTab !== "Debt" && marketCap(selectedTab)
        fetchQuantitativeAnalysisData(selectedTab)
    }, [])


    const handleChangeTab = (item: string) => {
        setCreditFilter(1);
        setIssuerFilter(1);
        setSelectedTab(item)
        totalCardValues(item)
        fetchInvestorLevelAmcPerformance({
            selectedCategory: item
        })
        getTopSchemes({ selectedCategory: item })
        item != "Debt" && getPortfolioExposure(item)
        item != "Debt" && marketCap(item)
        item === "Debt" && fetchRatingAndMaturity(item)
        item === "Debt" && fetchIssuerAllocation(item)
        fetchQuantitativeAnalysisData(item)
    }

    const handleamcTableSorting = async (orderBy: string, order: Order) => {
        setAMCSortingObj({ orderBy, order })
        fetchInvestorLevelAmcPerformance({
            order,
            orderBy,
            selectedCategory: selectedTab
        })
    }

    return (
        <Box>

            <Box sx={{ width: '100%' }}>
                <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', mt: 2 }}>
                    <Typography
                        variant="body_600"
                        color={palette.text.primary}
                        sx={{ p: 1 }}>
                        Privacy Mode
                    </Typography>
                    {maskedData
                        ?
                        <IconButton
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                            onClick={() => setMaskedData(!maskedData)}
                        >
                            <HideIcon />
                        </IconButton>
                        :
                        <IconButton
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                            onClick={() => setMaskedData(!maskedData)}
                        >
                            <ViewIcon />
                        </IconButton>
                    }
                </Box>
            </Box>
            {/* 4 Cards */}
            <Hidden only={'xs'}>
                <Grid container spacing={2} mt={'25px'}>
                    <Grid item width={'100%'} lg={3}>
                        <Card Icons={MoneyGrow}
                            title="Market Value"
                            value={cardValues?.result?.totalMarketValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalMarketValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalMarketValue, locale, currencyCode })}`}
                            loading={cardLoader}
                            percent={false}
                            maskedData={maskedData}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={CurrencyIcon}
                            title="Invested Value"
                            value={cardValues?.result?.totalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalInvestedValue, locale, currencyCode })}`}
                            loading={cardLoader}
                            percent={false}
                            maskedData={maskedData}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={ChartIcon}
                            title="Gain/Loss (%)"
                            value={cardValues?.result?.gainLoss < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.gainLoss), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.gainLoss, locale, currencyCode })}`}
                            color={cardValues?.result?.gainLoss >= 0 ? palette.success[500] : palette.error[500]}
                            loading={cardLoader}
                            percent
                            percentageValue={cardValues?.result?.percentage}
                            maskedData={maskedData}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={PercentageIcons}
                            title="Absolute Return %"
                            value={`${!Number.isNaN(Number(cardValues?.result?.irr)) ?
                                Math.round(cardValues?.result?.irr * 100) / 100 : '0'}%`}
                            color={(cardValues?.result?.irr ?? 0) >= 0 ? palette.success[500] : palette.error[500]}
                            loading={cardLoader}
                            percent={false}
                            maskedData={maskedData}
                        />
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden smUp={true}>
                <Box sx={{ width: '100%', borderRadius: '15px', flexDirection: 'column', background: palette.background.paper, padding: '20px 18px', gap: '25px', mt: '30px' }}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <ResponsiveCard
                            title="Market Value"
                            value={cardValues?.result?.totalMarketValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalMarketValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalMarketValue, locale, currencyCode })}`}
                            maskedData={maskedData}
                        />
                        <ResponsiveCard
                            title="Invested Value"
                            value={cardValues?.result?.totalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalInvestedValue, locale, currencyCode })}`}
                            align="right"
                            maskedData={maskedData}
                        />
                    </Box>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mt: '25px' }}>
                        <ResponsiveCard
                            title="Gain/Loss (%)"
                            value={cardValues?.result?.gainLoss < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.gainLoss), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.gainLoss, locale, currencyCode })}`}
                            color={cardValues?.result?.gainLoss >= 0 ? palette.success[500] : palette.error[500]}
                            maskedData={maskedData}
                        />
                        <ResponsiveCard
                            title="Absolute Return %"
                            value={`${!Number.isNaN(Number(cardValues?.result?.irr)) ?
                                Math.round(cardValues?.result?.irr * 100) / 100 : '0'}%`}
                            color={(cardValues?.result?.irr ?? 0) >= 0 ? palette.success[500] : palette.error[500]}
                            align="right"
                            maskedData={maskedData}
                        />

                    </Box>
                </Box>
            </Hidden>


            {/* Tabs */}
            <Box mt={'45px'} sx={{ display: 'flex', flexDirection: 'row', gap: '10px', paddingBottom: '15px', borderBottom: `1px solid #CDCDCD`, overflowX: 'auto' }}>
                {tabsList.map((item, index) => <Box
                    component={'button'}
                    key={`${item}-${index}`}
                    onClick={() => handleChangeTab(item)}
                    sx={{ padding: '5px 15px', background: selectedTab === item ? palette.primary[500] : 'transparent', borderRadius: '7px', outline: 'none', border: 'none', cursor: 'pointer' }}>
                    <Typography variant="body_500" color={selectedTab === item ? palette.textDark.primary : palette.text.secondary}
                        sx={(theme: Theme) => ({
                            fontFamily: theme.typography.fontFamily,
                            letterSpacing: '0.02px'
                        })}
                    >{item}</Typography>
                </Box>)}
            </Box>

            {/* Main Content */}


            <Grid container sx={{ mt: '8px' }} columnSpacing={3} rowSpacing={3}>

                {(selectedTab === 'Equity') &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {marketCapData?.isSuccess === false || marketCapData?.result?.data?.length === 0 ? <ErrorText /> :
                                        <CustomePieChart {...{ ...marketCapData?.result, isLoading: marketCapDataLoading, showSlider: true, maskedData }} />}

                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={portfolioLoader} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>

                                    {portfolioLoader === false && (portfolioExposureData?.isSuccess === false || portfolioExposureData?.result?.data?.length === 0) ? <ErrorText /> :
                                        <CustomePieChart {...{ ...portfolioExposureData?.result, isLoading: portfolioLoader, showSlider: true, maskedData }} />}
                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {(selectedTab === "Hybrid") &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>

                                    {marketCapData?.isSuccess === false || marketCapData?.result?.data?.length === 0 ? <ErrorText /> :
                                        <CustomePieChart {...{ ...marketCapData?.result, isLoading: marketCapDataLoading, showSlider: true, maskedData }} />}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={portfolioLoader} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {portfolioLoader === false && (portfolioExposureData?.isSuccess === false || portfolioExposureData?.result?.data?.length === 0) ? <ErrorText /> :
                                        <CustomePieChart {...{ ...portfolioExposureData?.result, isLoading: portfolioLoader, showSlider: true, maskedData }} />}

                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {selectedTab === 'Debt' &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>{issuerFilter === 1 ? "Issuer Category Allocation" : "Instrument Category Allocation"}</Typography>
                                    <CustomDropdown setFilterValue={setIssuerFilter} IsLoading={issueLoader} options={[
                                        {
                                            "label": "Issuer Category Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Instrument Category Allocation",
                                            "value": 2
                                        },

                                    ]} defaultValue={1} />
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {issueLoader === false && (issuerData?.isSuccess === false || issuerData?.result?.data?.length === 0) ? <ErrorText /> : <CustomePieChart {...{ ...issuerData?.result, isLoading: issueLoader, showSlider: true, maskedData }} />}

                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px',

                                    }}>{creditFilter === 1 ? "Credit Rating Allocation" : "Average Maturity Allocation"}</Typography>
                                    <CustomDropdown setFilterValue={setCreditFilter} IsLoading={creditLoader} options={[
                                        {
                                            "label": "Credit Rating Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Average Maturity Allocation",
                                            "value": 2
                                        },
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {creditLoader === false && (creditData?.isSuccess === false || creditData?.result?.data?.length === 0) ? <ErrorText /> : <CustomePieChart {...{ ...creditData?.result, isLoading: creditLoader, showSlider: true, title: 'Credit Rating Allocation', maskedData }} />}

                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {/* {selectedTab === 'Hybrid' &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <CustomePieChart {...{ ...investorProfileFixture.assetAllocation, isLoading: false, showSlider: true }} />
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={false} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <CustomePieChart {...{ ...investorProfileFixture.assetAllocation, isLoading: false, showSlider: true }} />
                            </Box>
                        </Grid>
                    </>
                } */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InvestorLevelAMCPerformanceAnalysis
                        filters={false}
                        title='AMC Performance Analysis'
                        tableData={categoryWiseAmcData?.result}
                        isLoading={categoryWiseAmcDataLoading}
                        handleTableSorting={handleamcTableSorting}
                        sortingObj={amcSortingObj}
                        setSortingObj={setAMCSortingObj}
                        maskedData={maskedData}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TopScheme
                        title='Top 10 Schemes'
                        tableData={topSchemesData?.result?.topSchemes?.data}
                        isLoading={schemesLoader}
                        maskedData={maskedData}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <QuantitativeAnalysis
                        title='Quantitative Analysis'
                        tableData={quantitativeAnalysisData}
                        isLoading={quantitativeAnalysisDataLoading}
                        selectedTab={selectedTab}
                        maskedData={maskedData}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

interface TopSchemProps {
    title: string
    isLoading: boolean,
    tableData: any,
    selectedTab?: string
    maskedData?: boolean
}

export const TopScheme = ({ title, tableData, isLoading, maskedData }: TopSchemProps) => {
    const { palette, typography } = useTheme()
    return (
        <Box sx={{
            padding: { xs: '25px 15px 25px 15px', sm: '25px 30px 45px 30px' },
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <TopSchemTable
                            tableBodyData={tableData || []}
                            maskedData={maskedData}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={TopSchemeTableHead}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={
                        (orderBy: string, order: string) =>
                            console.log("Sort clicked", "orderBy", orderBy, "order", order)}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                    manualResponsiveBody={true}
                    hideResponsiveHeader={true}
                    ManualResponsiveBodyComponent={
                        <MobileResponsiveBodyTopScheme
                            // selectedHeaderKey={TopSchemeTableHead[1]?.id || 'amount'}
                            data={tableData || []}
                            maskedData={maskedData}

                        />
                    }
                />
            </Box>
        </Box>
    )
}

export const QuantitativeAnalysis = ({ title, tableData, isLoading, selectedTab, maskedData }: TopSchemProps) => {
    const { palette, typography } = useTheme()

    return (
        <Box sx={{
            padding: { xs: '25px 15px 25px 15px', sm: '25px 30px 45px 30px' },
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <QuantitativeAnalysisTable
                            tableBodyData={tableData}
                            selectedTab={selectedTab ?? ''}
                            maskedData={maskedData}
                        />
                    }
                    tableData={tableData}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={QuantitativeAnalysisHead}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                    manualResponsiveBody={true}
                    hideResponsiveHeader={true}
                    ManualResponsiveBodyComponent={
                        <QuantitativeAnalysisMobileResponsiveBody
                            maskedData={maskedData}
                            selectedTab={selectedTab ?? ''}
                            // selectedHeaderKey={QuantitativeAnalysisHead[1]?.id || 'value'}
                            data={tableData || []}

                        />
                    }
                />
            </Box>
        </Box>
    )
}

// Custom Mobile Responsive Body Component for TopScheme
// function MobileResponsiveBody({ selectedHeaderKey, data }: { selectedHeaderKey: string, data: any[] }): JSX.Element {
//     const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

//     const getFormattedValue = (item: any, key: string) => {
//         switch (key) {
//             case 'schemeName': {
//                 const folioCheck = item?.folioNo === '0' ? '' : `(${item?.folioNo})`;
//                 return `${item?.schemeName}${folioCheck}`;
//             }
//             case 'amount':
//                 return item?.amount < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.amount), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.amount, locale, currencyCode })}`;
//             case 'percentage':
//                 return item?.percentage ? `${(item?.percentage).toFixed(2)}%` : "-";
//             case 'nav':
//                 return item?.nav ? `${(item?.nav).toFixed(2)}` : "-";
//             case 'units':
//                 return item?.units ? `${(item?.units).toFixed(2)}` : "-";
//             default:
//                 return item?.[key] ?? "-";
//         }
//     };

//     return (
//         <>
//             {data.map((item: any, index: number) => (
//                 <TableRow key={index}>
//                     <TableCell align="left">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 '&:hover': {
//                                     color: theme.palette.primary[500]
//                                 },
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, 'schemeName')}
//                         </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, selectedHeaderKey)}
//                         </Typography>
//                     </TableCell>
//                 </TableRow>
//             ))}
//         </>
//     );
// }

function MobileResponsiveBodyTopScheme({
    data,
    maskedData = false,

}: {
    data: any[]
    maskedData?: boolean

}): JSX.Element {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const getFormattedValue = (item: any, key: string) => {
        switch (key) {
            case 'schemeName': {
                const folioCheck = item?.folioNo === '0' ? '' : `(${item?.folioNo})`;
                return `${item?.schemeName}${folioCheck}`;
            }
            case 'amount':
                return maskedData
                    ? "****"
                    : item?.amount < 0
                        ? `- ${formatCurrency({ value: Math.abs(item?.amount), locale, currencyCode })}`
                        : `${formatCurrency({ value: item?.amount, locale, currencyCode })}`;
            case 'exposure':
                return maskedData
                    ? '***'
                    : `${item?.exposure != null ? item.exposure.toFixed(2) : '0'}%`;
            default:
                return item?.[key] ?? "-";
        }
    };



    return (
        <Box display="flex" flexDirection="column" gap={2}>
            {data.map((item, index) => (
                <Box
                    key={`${item?.schemeName ?? ""}-${index}`}
                    sx={(theme: Theme) => ({
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "12px",
                        padding: "16px",
                        backgroundColor: theme.palette.background.paper,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                            borderColor: theme.palette.primary[500],
                            boxShadow: theme.shadows[2],
                        },
                    })}
                >
                    {/* Scheme Name (with folio) */}
                    <Typography
                        variant="body_600"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.primary,
                            fontSize: "16px",
                            marginBottom: "8px",
                        })}
                    >
                        {getFormattedValue(item, "schemeName")}
                    </Typography>

                    {/* Other Scheme Details - Left/Right Alignment */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "16px"
                        }}
                    >
                        {/* Left Column - Amount */}
                        <Box sx={{ justifySelf: "flex-start", textAlign: "left" }}>
                            <Typography
                                variant="overline"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    marginBottom: "4px",
                                    display: "block",
                                    textAlign: "left"
                                })}
                            >
                                {TopSchemeTableHead.find(h => h.id === 'amount')?.label || 'AMOUNT'}
                            </Typography>
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    textAlign: "left"
                                })}
                            >
                                {getFormattedValue(item, "amount")}
                            </Typography>
                        </Box>

                        {/* Right Column - Exposure */}
                        <Box>
                            <Typography
                                variant="overline"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    marginBottom: "4px",
                                    display: "block",
                                    textAlign: "right"
                                })}
                            >
                                {TopSchemeTableHead.find(h => h.id === 'exposure')?.label || 'EXPOSURE'}
                            </Typography>
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    textAlign: "right"
                                })}
                            >
                                {getFormattedValue(item, "exposure")}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
}

// Custom Mobile Responsive Body Component for QuantitativeAnalysis
// function QuantitativeAnalysisMobileResponsiveBody({ selectedHeaderKey, data }: { selectedHeaderKey: string, data: any[] }): JSX.Element {
//     const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

//     const getFormattedValue = (item: any, key: string) => {
//         switch (key) {
//             case 'amcname':
//                 return item?.amcname ?? "-";
//             case 'value':
//                 return item?.value ? `${(item?.value).toFixed(2)}` : "-";
//             case 'percentage':
//                 return item?.percentage ? `${(item?.percentage).toFixed(2)}%` : "-";
//             case 'amount':
//                 return item?.amount < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.amount), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.amount, locale, currencyCode })}`;
//             case 'nav':
//                 return item?.nav ? `${(item?.nav).toFixed(2)}` : "-";
//             case 'units':
//                 return item?.units ? `${(item?.units).toFixed(2)}` : "-";
//             default:
//                 return item?.[key] ?? "-";
//         }
//     };

//     return (
//         <>
//             {data.map((item: any, index: number) => (
//                 <TableRow key={index}>
//                     <TableCell align="left">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 '&:hover': {
//                                     color: theme.palette.primary[500]
//                                 },
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, 'amcname')}
//                         </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, selectedHeaderKey)}
//                         </Typography>
//                     </TableCell>
//                 </TableRow>
//             ))}
//         </>
//     );
// }

function QuantitativeAnalysisMobileResponsiveBody({
    data,
    maskedData = false,
    selectedTab,

}: {
    data: any[];
    maskedData?: boolean;
    selectedTab: string;

}): JSX.Element {
    const avoidAmcNames = ['average maturity', 'duration', 'ytm'];


    return (
        <Box display="flex" flexDirection="column" gap={2}>
            {data.map((item, index) => {
                if (
                    (selectedTab?.toLowerCase() === "equity" || selectedTab?.toLowerCase() === "hybrid") &&
                    avoidAmcNames.includes(item?.amcname?.toLowerCase())
                ) {
                    return null; // same as desktop filter
                }

                const valueToShow = item?.holding; // always use holding (matches desktop)

                return (
                    <Box
                        key={`${item?.amcname ?? ""}-${index}`}
                        sx={(theme: Theme) => ({
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: "12px",
                            padding: "12px",
                            backgroundColor: theme.palette.background.paper,
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                                borderColor: theme.palette.primary[500],
                                boxShadow: theme.shadows[2],
                            },
                        })}
                    >
                        {/* AMC Name */}
                        <Typography
                            variant="body_600"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                fontSize: "16px",
                            })}
                        >
                            {item?.amcname ?? "-"}
                        </Typography>

                        {/* Holding (same as desktop second column) */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                variant="overline"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                })}
                            >
                                {QuantitativeAnalysisHead.find(h => h.id === "holding")?.label || "Holding"}
                            </Typography>
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                })}
                            >
                                {maskedData
                                    ? "***"
                                    : !Number.isNaN(Number(valueToShow ?? 0))
                                        ? Math.round((valueToShow ?? 0) * 100) / 100
                                        : "0"}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}

